import React from 'react';
import { useIntl } from 'react-intl';
import { ListSubheader, MenuItem, Select } from '@mui/material';
import useTranslate from '../../../Hooks/useTranslate';
import { cellGroupsForType } from '../columns/CellRegistry';

/**
 * Picks the cell an entry is drawn by, out of the cells the registry holds.
 *
 * Grouped rather than merely ordered: the cells that suit the key's type are what one is usually
 * after, and the rest have to stay reachable, since a key the catalogue types as text may hold a
 * figure. Which group a cell falls in is the registry's answer, not this one's.
 *
 * @param {Object} props - Component props.
 * @param {String} props.value - The cell chosen, empty for the value as it stands.
 * @param {String} props.type - The key's catalogue data type, which decides the grouping.
 * @param {Function} props.onChange - Receives the cell chosen.
 *
 * @returns {React.JSX.Element}
 */
const CellSelect = function CellSelect({
  value = '',
  type = '',
  onChange = () => {},
}) {
  const intl = useIntl();
  const translate = useTranslate();

  return (
    <Select
      size="small"
      value={value ?? ''}
      displayEmpty
      onChange={(e) => onChange(e.target.value)}
      sx={{ width: '150px', flex: 'none' }}
    >
      <MenuItem value="">{intl.messages.CELL_PLAIN}</MenuItem>
      {cellGroupsForType(type).flatMap(({ label, cells }) => [
        <ListSubheader key={label}>{translate(label)}</ListSubheader>,
        ...cells.map(({ cell, label: wording }) => (
          <MenuItem key={cell} value={cell}>
            {translate(wording)}
          </MenuItem>
        )),
      ])}
    </Select>
  );
};

export default CellSelect;
